import React, { useState } from 'react';
import { Container, Row, InputGroup } from 'react-bootstrap';
import SVG from 'react-inlinesvg';

// Page Components
import Input from 'components/Form/Input/Input';
import Button from 'components/Button/Button';

// SCSS
import styles from './Filter.module.scss';

// SVGs
import Keyword from 'assets/svgs/Careers/filter-keyword.svg';

interface Props {
  keyword?: string;
  setKeyword: (searchText: string) => void;
}

const Filter: React.FC<Props> = ({ keyword, setKeyword }: Props) => {
  const [searchText, setSearchText] = useState<string>(keyword || '');

  const handleSearchTextChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event.target;
    setSearchText(value);
  };

  const triggerSearch = () => {
    setKeyword(searchText);
  };

  // trigger search on press of enter/return
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.which === 13 || event.charCode === 13) {
      setKeyword(searchText);
    }
  };

  return (
    <div className={styles.filterForm}>
      <Container>
        <Row>
          <InputGroup className={styles.filterGroup}>
            <InputGroup.Prepend
              className={`${styles.keywordPrepend} ${styles.filterPrepend}`}
            >
              <InputGroup.Text>
                <SVG
                  baseURL="/"
                  cacheRequests={true}
                  className="keyword-filter"
                  description="Keyword Filter Icon"
                  loader={<span>Loading...</span>}
                  src={Keyword}
                />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Input
              class={`${styles.keywordFilter} ${styles.inputFilter}`}
              placeholder="Keyword Search"
              value={searchText}
              onChange={handleSearchTextChange}
              onKeyPress={handleKeyPress}
            />
            <Button
              type={`branding ${styles.submitFilter}`}
              label="Search"
              onClick={triggerSearch}
            />
          </InputGroup>
        </Row>
      </Container>
    </div>
  );
};

export default React.memo(Filter);
